// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"c0a4a32e","228":"9f267e77","367":"4d42e1b2","438":"0f0263b4","487":"0d759599","522":"a291e231","533":"16bb2530","591":"69a781a8","615":"eb5bd937","696":"ef1d534e","816":"37eabe5a","847":"4cf3190e","861":"a7e52ee9","907":"22c51871","914":"a0d08403","938":"afb172cd"}[chunkId] + ".chunk.js";
};